import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  theme: "light", 
  notificationsEnabled: true,
  language: "English", 
};

const partnerSettingsSlice = createSlice({
  name: "userSettings",
  initialState,
  reducers: {
    setTheme(state, action) {
      state.theme = action.payload;
    },
    toggleNotifications(state) {
      state.notificationsEnabled = !state.notificationsEnabled;
    },
    setLanguage(state, action) {
      state.language = action.payload;
    },
  },
});

export const { setTheme, toggleNotifications, setLanguage } = partnerSettingsSlice.actions;

export default partnerSettingsSlice.reducer;
